<template>
  <div class="pt-routes" v-loading="loading">
    <div class="pt-routes-header">
      <r-text>
        Список маршрутов
      </r-text>
    </div>
    <div class="pt-routes-filter">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filter"
        placeholder="Поиск по маршрутам"
      />
    </div>
    <ul class="pt-routes-systems" v-if="systems.length">
      <li class="pt-routes-system" v-for="system in systems" :key="system.id">
        <r-text type="caption">
          {{ system.name }}
        </r-text>
        <pt-routes-list :routes="system.routes" @fly-to-route="flyToRoute" />
      </li>
    </ul>
    <div class="pt-routes-nodata" v-else>
      <r-text type="caption">
        Не найдено ни одного маршрута
      </r-text>
    </div>
  </div>
</template>

<script>
import PtRoutesList from "./pt-routes-list";

export default {
  components: {
    PtRoutesList
  },
  data() {
    return {
      filter: "",
      loading: false,
      routes: []
    };
  },
  computed: {
    systems() {
      const filtered = this.routes.filter(r => {
        const name = r.name || "";

        return name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
      });
      const systems = filtered.reduce((prev, el) => {
        const systemId = el.transport_system_id;
        if (prev[systemId]) return prev;
        const system = this.transportSystems.find(s => s.id === systemId);
        if (!system) return prev;

        prev[systemId] = {
          id: systemId,
          name: system.name
        };
        return prev;
      }, {});

      return Object.values(systems).map(s => ({
        ...s,
        routes: this.routes
          .filter(r => !r.rev)
          .filter(r => r.transport_system_id === s.id)
      }));
    },
    transportSystems() {
      return this.$store.state.publicTransport.transportSystems || [];
    }
  },
  watch: {
    "$store.state.publicTransport.saved"(value) {
      if (!value) return;

      this.getRoutes();
      this.$store.commit("SET_PT_UPDATED", false);
    }
  },
  methods: {
    flyToRoute(route) {
      this.$store.commit("FLY_TO_ROUTE", route);
      this.$store.commit("SET_SELECTED_ROUTE", route);
    },
    async getTransportSystems() {
      try {
        const { ids } = this.$store.state.publicTransport.model;
        const url = `objectInfo/${ids.transport_systems}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });
        this.$store.commit("SET_PT_STATE_PROP", {
          name: "transportSystems",
          value: Object.values(data)
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getRoutes() {
      const { ids } = this.$store.state.publicTransport.model;
      const id = ids["line_routes"];

      try {
        this.loading = true;
        const config = {
          only: [
            "id",
            "geom",
            "transport_system_id",
            "reverse_route_id",
            "rev",
            "name"
          ],
          include: {
            reverse_route: {
              only: ["geom"]
            }
          }
        };
        const url = `objectInfo/${id}?config=${JSON.stringify(config)}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });
        this.routes = Object.values(data);
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    }
  },
  created() {
    if (!this.$store.state.publicTransport.transportSystems) {
      this.getTransportSystems();
    }

    this.getRoutes();
  }
};
</script>

<style lang="scss">
.pt-routes {
  padding: 16px;

  &-header {
    margin-bottom: 16px;
  }

  &-filter {
    margin-bottom: 16px;
  }

  &-system {
    &:not(:first-child) {
      margin-top: 16px;
    }
  }

  &-nodata {
    padding: 8px;
    text-align: center;
  }
}
</style>
